var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAquisitionPriceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7B84B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.7981H28L30 15.5288V27.6537C30 28.1688 29.5523 28.5864 29 28.5864H11C10.4477 28.5864 10 28.1688 10 27.6537V15.5326L12 11.7981ZM21 22.0576V18.3269H19V22.0576H16L20 25.7884L24 22.0576H21ZM27.7643 15.5288L26.7643 13.6635H13.2373L12.2373 15.5288H27.7643Z",
    fill: "#F7B84B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquisitionPriceIcon);
export default __webpack_public_path__ + "static/media/AquisitionPriceIcon.96e7e5c30df232bdcf3e8f499459a84e.svg";
export { ForwardRef as ReactComponent };